/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface GeneratedReferralDocumentInput
 */
export interface GeneratedReferralDocumentInput {
    /**
     *
     * @type {any}
     * @memberof GeneratedReferralDocumentInput
     */
    generated_document_type: GeneratedReferralDocumentInputGeneratedDocumentTypeEnum;
}


/**
 * @export
 */
export const GeneratedReferralDocumentInputGeneratedDocumentTypeEnum = {
    SummaryReport: 'summary_report',
    RulesReport: 'rules_report',
    DataPullsReport: 'data_pulls_report',
    SOffenderReport: 's_offender_report',
    MedicationsReport: 'medications_report',
    InsuranceEligibilityCheck: 'insurance_eligibility_check',
    AdvancedAiInsuranceCheck: 'advanced_ai_insurance_check',
    PalAuthSubmissionPackage: 'pal_auth_submission_package',
    PdpmReport: 'pdpm_report',
    PccFaceSheetReport: 'pcc_face_sheet_report',
    PccOrderSummaryReport: 'pcc_order_summary_report',
    PccMdHistoryReport: 'pcc_md_history_report'
} as const;
export type GeneratedReferralDocumentInputGeneratedDocumentTypeEnum = typeof GeneratedReferralDocumentInputGeneratedDocumentTypeEnum[keyof typeof GeneratedReferralDocumentInputGeneratedDocumentTypeEnum];


/**
 * Check if a given object implements the GeneratedReferralDocumentInput interface.
 */
export function instanceOfGeneratedReferralDocumentInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "generated_document_type" in value;

    return isInstance;
}

export function GeneratedReferralDocumentInputFromJSON(json: any): GeneratedReferralDocumentInput {
    return GeneratedReferralDocumentInputFromJSONTyped(json, false);
}

export function GeneratedReferralDocumentInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratedReferralDocumentInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'generated_document_type': json['generated_document_type'],
    };
}

export function GeneratedReferralDocumentInputToJSON(value?: GeneratedReferralDocumentInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'generated_document_type': value.generated_document_type,
    };
}

